import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";
import { IModeOfCourse } from "../../../feature-module/pages/masters/modesOfCourse";

interface IModesOfCourseState {
  data: IModeOfCourse[];
  loading: boolean;
  error: string | null;
  total: number;
  page: number;
  limit: number;
}

const initialState: IModesOfCourseState = {
  data: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  limit: 10,
};

export const getAllModesOfCourse = createAsyncThunk(
  'get/allModesOfCourse',
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.MASTERS.FIND_ALL_MODE_OF_COURSE,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const modesOfCourseSlice = createSlice({
  name: "modesOfCourse",
  initialState,
  reducers: {
    resetModesOfCourseState: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.total = 0;
      state.page = 1;
      state.limit = 10;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllModesOfCourse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllModesOfCourse.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data || [];
        state.total = action.payload.data.total || 0;
        state.page = action.payload.data.page || 1;
        state.limit = action.payload.data.limit || 10;
        state.error = null;
      })
      .addCase(getAllModesOfCourse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.data = [];
      });
  },
});

export const { resetModesOfCourseState } = modesOfCourseSlice.actions;
export default modesOfCourseSlice.reducer;